import React, { useState} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter as Router, Route, Link, Routes} from "react-router-dom";
import "./App.css";
import Button  from "react-bootstrap/Button";
import Airtime from "./components/Airtime";
import Tokens from "./components/Tokens";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import Home from "./components/Home";

function App() {
  const [showAirtime, setShowAirtime] = useState(false);
  const [showToken, setShowToken] = useState(false);
  
  const handleClose = () => setShowAirtime(false);
  const handleShow = () => setShowAirtime(true);
  const handleCloseToken = () => setShowToken(false);
  const handleShowToken = () => setShowToken(true);
  return (
  
    <Router>
      <title>GetAirtime</title>
      <div className="">
      <nav className="navbar navbar-expand ">
      <div className="container-fluid">
      <Link to={"/"}>
      <Button variant=" rounded-3" className="menu-btn" size="lg">
          RDS Home
        </Button>   
        </Link>  
        <div className="navbar-nav ">
          
          <li className="nav-item me-auto">
            <Link to={"/about"} className="nav-link color-nav-text">
                <Button variant=" rounded-3" className="menu-btn" size="lg">
                      About Us
                </Button>
            </Link>
          </li>
          <li className="nav-item me-auto">
            <Link to={"/contact"} className="nav-link color-nav-text ">
            <Button variant=" rounded-3" className="menu-btn" size="lg">
              Contact Us
            </Button>
            </Link>
          </li>        
        </div>    
        </div>
      </nav>
  
      <div className="container mt-3">
        <Routes>
          <Route exact path="/"  element={<Home showAirtimeModal={handleShow} 
          showTokenModal={handleShowToken}/>} />
          <Route exact path="/about" element={<AboutUs />} />
          <Route exact path="/contact" element={<ContactUs />} />
        </Routes>
      </div>
      <Airtime show={showAirtime} onHide={handleClose} onClose={handleClose} />
    {/*  <Tokens show={showToken} onHide={handleCloseToken} onClose={handleCloseToken} />*/}
      </div>


    </Router>

    
    
  );
}

export default App; 